import { takeLatest, call, put, select } from 'redux-saga/effects';
import axiosInstance from '../../services/AuthHeader';
import { setSending, unsetSending } from '../reducers/serverCommunication';
import {
  setFetchResourceDataFailure,
  setFetchResourceDataRequest,
  setFetchResourceDataSuccess,
} from '../reducers/resourceDataReducer';
import { selectUserId } from '../reducers/session';

export const SAGA_GET_RESOURCE_DATA = 'SAGA_GET_RESOURCE_DATA';

export function sendGetResourceData() {
  return { type: SAGA_GET_RESOURCE_DATA };
}

const handleGetResourceData = async ({ userId }) =>
  axiosInstance.get('/api/pop/users/' + userId + '/resources').then((res) => res.data);

export function* getResourceData() {
  yield put(setSending);
  yield put(setFetchResourceDataRequest);
  try {
    let userId = yield select(selectUserId);
    const response = yield call(handleGetResourceData, { userId });
    yield put(setFetchResourceDataSuccess(response));
  } catch (error) {
    yield put(setFetchResourceDataFailure(error.response));
  } finally {
    yield put(unsetSending);
  }
}

export function* watchForGetResourceData() {
  yield takeLatest(SAGA_GET_RESOURCE_DATA, getResourceData);
}
